import { observer } from 'mobx-react-lite'
import { FullPageWrapper } from 'shared/ui'
import { useClickToTextPageContext } from 'pages/clickToText/context'
import { ClickToTextList } from './ClickToTextList'

export const AllClickToText = observer(() => {
  const { setIsClickToTextActionShown } = useClickToTextPageContext()

  return (
    <FullPageWrapper>
      <ClickToTextList setIsClickToTextActionShown={setIsClickToTextActionShown} />
    </FullPageWrapper>
  )
})
